import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UiIcon, UiButton, UiTooltip, UiPopover } from 'ui-components';
import { useNotifications } from 'hooks';
import { PropTypes } from 'prop-types';
import { fetchNotifications, seenAllNotifications } from 'store';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import translation from 'translation';
import ChangePasswordNotif from './change-password/ChangePasswordNotif';
import Notif from './notif/Notif';
import PdfNotif from './pdf/PdfNotif';
import NotifyAll from './all/NotifyAll';
import { StyledPopoverContainer, StyledTogglerWrapper } from './styles';

export const renderNotificationItem = (notification, index) => {
  const { t } = translation;
  if (notification?.type === 'notify-all')
    return (
      <React.Fragment key={`notif_all_${notification?.id}`}>
        {index > 0 && <hr className='hr mt-12' />}
        <NotifyAll {...notification} />
      </React.Fragment>
    );

  // خروجی pdf
  if (notification?.type === 'bulletin_export_pdf')
    return (
      <React.Fragment key={`notif_pdf_${notification?.id}`}>
        {index > 0 && <hr className='hr mt-12' />}
        <PdfNotif {...notification} />
      </React.Fragment>
    );

  // خروجی excel
  if (
    notification?.type === 'search_excel' ||
    notification?.type === 'bulletin_export_docx'
  )
    return (
      <React.Fragment key={`notif_notif_${notification?.id}`}>
        {index > 0 && <hr className='hr mt-12' />}
        <Notif
          {...notification}
          name={
            notification?.type === 'search_excel'
              ? t('notifications:excel')
              : t('notifications:word')
          }
        />
      </React.Fragment>
    );

  // تغییر رمز عبور
  if (notification?.type === 'password_expired_notification')
    return (
      <React.Fragment key={`notif_password_expired_${notification?.id}`}>
        {index > 0 && <hr className='hr mt-12' />}
        <ChangePasswordNotif {...notification} />
      </React.Fragment>
    );

  return null;
};

const SocketNotifications = ({ className, icon, ...props }) => {
  const { t } = useTranslation();
  const title = t('notifications:alerts');
  const notifications = useSelector(
    (state) => state.notificationReducer.notifications
  );
  const unseenCount = useSelector((state) => state.notificationReducer.unseen);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useNotifications();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleSeenAllNotifications = () => {
    dispatch(seenAllNotifications());
  };

  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    handleSeenAllNotifications();
  };

  return (
    <div className={className}>
      <StyledTogglerWrapper>
        <UiTooltip title={title}>
          <UiIcon icon={icon} size={20} onClick={handleToggle} />
        </UiTooltip>
        {unseenCount > 0 && (
          <bdi
            className='unseen-notification-count flex center'
            onClick={handleSeenAllNotifications}
          >
            {unseenCount < 100 ? unseenCount : '99+'}
          </bdi>
        )}
      </StyledTogglerWrapper>
      <UiPopover
        id={open ? 'notificationsPopover' : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        paperStyles={{ marginTop: '25px' }}
      >
        <StyledPopoverContainer data-testid={props?.['data-testid']}>
          <div className='socket-notifications'>
            <div className='container'>
              <div className='flex header'>
                <label className='label'>{title}</label>
              </div>
              {notifications?.data.map((notification, index) =>
                renderNotificationItem(notification, index)
              )}
              {/* اگر نوتیف‌ها خالی بود - فعلا فقط برای pdf است */}
              {notifications?.data?.length <= 0 && (
                <div className='flex center mtb-50 muted'>
                  <UiIcon icon='ri-notification-2-line' className='ml-10' />
                  <span>
                    {t('notifications:yourListIsEmpty', {
                      title,
                    })}
                  </span>
                </div>
              )}
            </div>
            <div className='display-notification-list-btn'>
              <Link to='/notifications'>
                <UiButton variant='text'>
                  {t('notifications:viewlist', { title })}
                </UiButton>
              </Link>
            </div>
          </div>
        </StyledPopoverContainer>
      </UiPopover>
    </div>
  );
};

SocketNotifications.propTypes = {
  'data-testid': PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

export default memo(SocketNotifications);
